import Image, { ImageProps } from '@web/components/Image'

import styles from '../MissionCard.module.scss'

interface Props {
  image: ImageProps['src']
}

const NoContent = ({ image }: Props) => {
  return (
    <div className={styles.no_data_area}>
      {/* 다크 이미지: MissionReviewMenuDarkImage */}
      <Image className={styles.img} src={image} width="100%" height="auto" alt="" />
    </div>
  )
}

export default NoContent
